<template>
    <div>
        <item-detail-component :item-type="'premiumMarketDetail'" :item-key="itemKey"></item-detail-component>
        <auction-history-modal></auction-history-modal>
        <commission-info-modal></commission-info-modal>
        <share-modal></share-modal>
        <gift-item-modal></gift-item-modal>
    </div>
</template>

<script>
import AuctionHistoryModal from "@/components/modal/AuctionHistoryModal";

import ItemDetailComponent from "@/components/item/ItemDetailComponent";
import CommissionInfoModal from "@/components/modal/CommissionInfoModal";
import ShareModal from "@/components/modal/ShareModal";
import GiftItemModal from "@/components/modal/GiftItemModal";

export default {
    name: "PremiumMarketDetail",
    mixins: [],
    components: {
        GiftItemModal,
        ShareModal,
        CommissionInfoModal,
        ItemDetailComponent,
        AuctionHistoryModal
    },
    inject: [],
    provide() {
        return {}
    },
    props: {},
    data() {
        return {
            itemKey: '',
        }
    },
    beforeRouterEnter() {
    },
    created() {
        this.itemKey = this.$route.params.idx
    },
    mounted() {

    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {},
    watch: {},
}
</script>

<style scoped>

</style>